import React, { useState } from "react";
import Button from "../../Buttons/Button";

const CustomHourPicker = ({
  onChange,
  value,
  cancelEdit,
  saveEdit,
  roundTime = false,
}) => {
  const [inputValue, setInputValue] = useState(value || "");

  const formatTime = (hours, minutes) => {
    // First ensure hours don't exceed 23
    if (hours >= 24) {
      return "23:59";
    }

    // Handle minute overflow
    if (minutes >= 60) {
      hours += Math.floor(minutes / 60);
      minutes = minutes % 60;
    }

    // Final check for max time
    if (hours >= 24) {
      return "23:59";
    }

    if (roundTime) {
      // Round minutes to nearest 15
      minutes = Math.round(minutes / 15) * 15;

      // Handle minute overflow after rounding
      if (minutes === 60) {
        hours += 1;
        minutes = 0;
      }

      // Final check after rounding
      if (hours >= 24) {
        return "23:59";
      }
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  const formatTimeInput = (input) => {
    if (!input) return "00:00";

    // Handle direct HH:mm format
    if (input.includes(":")) {
      let [hours, minutes] = input.split(":").map(Number);
      return formatTime(hours, minutes);
    }

    // Handle decimal format
    if (input.includes(".")) {
      const [hours, decimal] = input.split(".");
      const minutes = Math.round(Number(`0.${decimal}`) * 60);
      return formatTime(Number(hours), minutes);
    }

    // Handle full number format
    const numStr = input.replace(/[^0-9]/g, "");
    if (numStr.length <= 2) {
      return formatTime(Number(numStr), 0);
    } else {
      let hours = Number(numStr.slice(0, -2));
      let minutes = Number(numStr.slice(-2));
      return formatTime(hours, minutes);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const formattedTime = formatTimeInput(inputValue);
      saveEdit(e, formattedTime);
    } else if (e.key === "Escape") {
      e.preventDefault();
      cancelEdit(e);
    }
  };

  const handleSave = (e) => {
    const formattedTime = formatTimeInput(inputValue);
    saveEdit(e, formattedTime);
  };

  return (
    <div className="flex-1 flex items-center gap-1 px-2">
      <Button
        type="icon"
        variant="text"
        color="dark"
        icon="close"
        size="xs"
        onClick={cancelEdit}
      />
      <input
        type="text"
        className="bg-transparent h-full w-full px-2 py-1 border-none rounded focus:outline-none text-center"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={value}
        autoFocus
        onFocus={(e) => e.target.select()}
      />
      <Button
        type="icon"
        variant="text"
        color="dark"
        icon="check"
        size="xs"
        onClick={handleSave}
      />
    </div>
  );
};

export default CustomHourPicker;
